<template>
  <div class="box5">
    <div class="box5block" ref="block"></div>
    <pageTitle
      title="全薪升级V8.6&nbsp;&nbsp;优质内容看技术"
      text="小程序+Vue3+React<br/>三大技术点，深入浅出带你透彻掌握前端技术"
      titleColor="#3E4F48"
      titColor="#4E5969"
    />
    <div class="box5-btm-box">
      <div class="box5-btm">
        <div
          class="subject-box"
          v-for="(item, index) in contentList"
          :key="index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" ref="item" @click="changeCur(index)">
            <div class="stage">{{ item.stage }}</div>
            <div class="title">{{ item.title }}</div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <div class="title-icon">
              <img
                src="../../../assets/coursePage/web/box5/1.png"
                alt
              />主要内容
            </div>
            <div class="main-content">
              <div class="block" v-for="i in item.content" :key="i" v-html="i"></div>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/web/box5/2.png"
                alt
              />可解决的现实问题
            </div>
            <div class="main-text">
              <p>{{ item.light }}</p>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/web/box5/3.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text main-text2">
              <p v-for="(k, kIndex) in item.ability" :key="kIndex">
                {{ k.name }}{{ k.txt }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="btn" @click="openDetail">查看详细大纲</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      prevItemHeight: 0,
      contentList: [
        {
          stage: "阶段一",
          title: "HTML+CSS 网页布局",

          content: ["具备PC端网页布局分析和网页开发能力"],
          light:
            "能够根据PxCook中的设计图，完成PC端静态网页的开发工作，学完此阶段，尚不能够达到企业用人标准。",
          ability: [
            {
              name: "HTML：",
              txt: "HTML 是网页开发的基础，从最简单的网页开发基础入手， 使用常见的标签制作网页内容。",
            },
            {
              name: "CSS：",
              txt: "在HTML结构的基础上，通过浮动、定位、Flex 精细控制网页布局，通过背景、圆角、阴影、渐变等装饰美化网页内容，结合转换、过渡、动画高级特性，增强用户体验，能够编写大型综合性网页。",
            },
            {
              name: "企业级小兔鲜儿电商项目：",
              txt: "基于设计稿编写网页，确保网页布局的高还原度，综合运用HTML、CSS的基础知识，归纳使用技巧，提升综合实战水平，借助PXCook协同工具，体验真实团队开发流程。",
            },
          ],
        },
        {
          stage: "阶段二",
          title: "移动Web网页开发",

          content: [
            "具备移动端网页布局分析和网页开发能力",
            "能够使用CSS高级特效，实现PC端和移动端炫酷页面的开发能力",
          ],
          light:
            "能够完成移动Web网页、响应式页面以及炫酷页面的开发工作，学完此阶段，尚不能够达到企业用人标准。",
          ability: [
            {
              name: "2D&3D转换与动画：",
              txt: "基于 CSS 的 2D 与 3D 转换特性制作动效网页。",
            },
            {
              name: "移动端布局：",
              txt: "深入理解屏幕相关知识，了解PC屏幕与移动屏幕本质上的差异，结合视口、媒体查询、rem等基础知识整合出稳定高效的移动屏幕适配方案。",
            },
            {
              name: "响应式布局：",
              txt: "基于媒体查询开发跨终端的网页，通过Bootstrap体会框架封装的高效性及组件化的复用性等实战化特征。",
            },
          ],
        },
        {
          stage: "阶段三",
          title: "JavaScript 网页编程",

          content: [
            "能够实现基于面向过程、面向对象以及链式编程的业务逻辑开发",
            "具备前端领域基础专业编程思维和能力",
          ],
          light:
            "能够完成PC端网页、移动Web网页、响应式页面中的功能和特殊效果的开发工作，学完此阶段，具备一定的企业基础用人标准，但尚未达到初级前端开发工程师水平。",
          ability: [
            {
              name: "JavaScript基础语法：",
              txt: "了解语言的基本概念，熟识语法规则，培养语言基础逻辑能力，建立良好的编程思维，具有一定的语言驾驭能力。",
            },
            {
              name: "Web API：",
              txt: "学习客户端开发技术，能够根据产品需求完成开发任务，如视觉交互、数据处理、安全、性能等，熟练掌握 DOM 操作的方法，能够分析视觉交互需求，结合 CSS 规则设计合理的 DOM 结构，完成开发任务。",
            },
            {
              name: "JavaScript进阶：",
              txt: "深入理解 ECMAScript 的知识体系及工作机制，熟悉 ES6+ 新的语法特性，注重抽象思维的培养，具备面向对象编程的能力。",
            },
          ],
        },
        {
          stage: "阶段四",
          title: "框架前置课",

          content: [
            "能够进行前后端数据交互，从而能够实现页面中数据增删改查操作 ",
            "能够根据Echarts，创建折线图、K线图、地图等图表 ",
          ],
          light:
            "能够完成前后端数据交互和基于前后端分离模式的开发的工作，学完此阶段，具备企业基础用人标准，能够达到初级前端开发工程师水平。",
          ability: [
            {
              name: "Ajax：",
              txt: "利用 axios 发起 Ajax 请求，实现前后端的数据交互。并讲解HTTP 请求的过程以及 Ajax 的底层原理。深入学习 JS 异步的底层原理，能够使用 Promise处理异步操作，并使用 async/await 简化异步操作。",
            },
            {
              name: "Git：",
              txt: "能够创建 Git 仓库管理前端项目，基于 Git 分支进行多人协同开发，并且能够把本地的 Git 仓库同步到远程码云或 Github 仓库中。",
            },
            {
              name: "数据看板项目 (Bootstrap +Echarts)：",
              txt: "数据看板是一个数据可视化项目，通过折线图、K线图、柱状图等图表形式归纳汇总大量数据，以实现更加直观的数据表达效果。学员通过学习该项目，能够掌握数据可视化、异步编程、实时数据获取等技术解决方案，适合有基础希望技能强化的IT人员继续学习。",
            },
            {
              name: "Node.js：",
              txt: "全面系统讲解 Node.js 中最核心的、必知必会的概念，能够基于模块化的开发思想优化项目代码，编写出高效、健壮的代码，同时培养出 Node.js 的编程思维。",
            },
            {
              name: "webpack：",
              txt: "建立前端工程化的开发思想，为工程化项目中脚手架的使用做基础铺垫。",
            },
          ],
        },
        {
          stage: "阶段五",
          title: "Vue.js 项目实战",
          content: [
            "基于Vue2+ElementUI+Vuex开发企业级PC端项目",
            "基于Vue3+TypeScript+pinia+vant开发企业级移动端项目",
            "基于token的前端登录解决方案",
            "基于RBAC大型中台项目权限控制解决方案",
            "组件封装解决方案&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
            "多语言动态主题解决方案",
          ],
          light:
            "能够使用Vue2技术栈、Vue3技术栈开发中大型企业级项目。学完此阶段，具备企业用人标准，能够达到中级前端开发工程师水平。",
          ability: [
            // {
            //   name: "webpack：",
            //   txt: "建立前端工程化的开发思想，为工程化项目中脚手架的使用做基础铺垫。",
            // },
            {
              name: "Vue2.x核心和Vue3.x核心：",
              txt: "通过 Vue2 和 Vue3 的基础学习，掌握企业开发中常见业务功能实现；通过深入 Vue 技术栈学习 vue-router vuex vantelement-ui 等主流技术，掌握企业级项目开发方式，如移动端H5项目实与PC端管理项目；通过 Vue3 结合 TypeScript 的技术学习，掌握大型企业级项目开发技巧。",
            },
            {
              name: "微前端：",
              txt: "掌握 qiankun 微前端库，重构巨石应用，做到与技术无关，例如：qiankunJS、实现 JS 沙箱、样式隔离、资源预加载，应用间通信，共用组件抽离。",
            },
            {
              name: "Three.js：",
              txt: "掌握 Three.js web 3D技术，具备大屏3D可视化开发能力，场景、摄像机、渲染器、坐标轴、GUI 工具、性能监视器、动效、进阶网络材质、灯光、Gsap 动画库。",
            },
            {
              name: "Vue原理：",
              txt: "掌握 Vue 底层原理，例如：响应式数据原理 Vue2&Vue3、虚拟 DOM、Diff 算法、AST 抽象语法树、Vue 响应式系统。",
            },
            {
              name: "面经全端项目（Vue2+ Vuex +ElementUI组件库 +Vant组件库）：",
              txt: "面经系统，由面试经验文章PC管理后台，个人H5端面试文章浏览组成。学员学习该项目，能够锻炼对 Vue 完整技术栈的运用。同时该项目还涵盖了 token身份认证、Vue 组件库、文件上传、富文本编辑器等前端技术解决方案，移动端开发，适合刚入手 Vue 框架、希望通过项目开发来巩固 Vue 基础的前端开发者学习。",
            },
            {
              name: "黑马智数（Vue + ElementUI组件库 + Vuex + vue-element-admin）：",
              txt: "黑马智数是一个数字化园区管理项目，该项目后台可以在线管理园区内的楼宇、企业、车辆和一体杆等资源，可视化大屏通过园区3D模型实时展示园区概况。学员通过该项目能学到如何用qiankun搭建微前端架构、用Echarts进行数据可视化以及前沿的3D模型展示等技术方案。"
            },
            {
              name: "优医问诊H5项目（Vue3 + Vant组件库 + Pinia + TypeScript）：",
              txt: "优医问诊是一个连接医生和患者的移动医疗行业H5应用，通过高效、快速的在线问诊服务，为患者提供健康帮助，涵盖了找医生、快速问诊、开药门诊、疾病查询，健康百科等功能。该项目基于Vue3+TypeScript进行开发，且引入下一代状态管理工具 Pinia 和热门的前端移动UI组件库 Vant ，采用全新技术栈，给学员带来企业级实战项目。"
            }
          ],
        },
        {
          stage: "阶段六",
          title: "微信小程序",
          content: [
            "具备原生微信小程序项目开发能力",
            "具备uniapp开发跨平台项目开发能力",
            "小程序微信登录实现方案",
            "小程序微信支付实现方案",
            "下拉刷新/上拉加载交互实现方案",
            "数据缓存实现方案",
          ],
          light:
            "能够使用原生小程序、uniapp前端应用框架进行微信小程序项目开发。学完此阶段，具备企业用人标准，能够达到中级前端开发工程师水平。",
          ability: [
            {
              name: "原生小程序：",
              txt: "了解小程序开发的一般流程，熟悉小程基础组件的使用， 能够基于 wxml 和 wxss 实现小程序的界面布局，基于模板的数据绑定实现数据的动态渲染，基于 API 实现与服务端的数据通信，以及熟悉其它高级 API 的使用。",
            },
            {
              name: "uni-app：",
              txt: "理解 uni-app 实现跨平台开发的原理机制，理清单文件组件与原生小程序组件的对应关系，以及uni-app 开发小程序与原生小程序的差异。",
            },
            {
              name: "享+生活原生小程序项目：",
              txt: "享+社区是一个生活类的小程序项目，主要服务于小区业主，为其提供生活家电报修|访客门禁通行的的功能，该项目主要包含房屋管理|报修管理|访客管理|用户管理|通知管理等功能模块，技术栈以原生小程序技术为主配合了 Vant 组件库。",
            },
            {
              name: "优医问诊项目：",
              txt: "优医问诊是一个连接医生和患者的移动医疗行业H5应用，通过高效、快速的在线问诊服务，为患者提供健康帮助，涵盖了找医生、快速问诊、开药门诊、疾病查询，健康百科等功能。该项目基于HBuilderX 使用 uni-app 开发跨端应用的能力，能够完成多端兼容、打包App、原生界面开发、地理定位、路径规划、即时通信。",
            },
          ],
        },
        {
          stage: "阶段七",
          title: "鸿蒙应用开发",
          content: [
            "一次开发，多端部署",
            "三层工程架构",
            "设备断点适配",
            "电商核心业务",
            "Hybrid混合开发",
            "WLAN和多媒体技术使用",
            "华为的应用生态使用"
          ],
          light:
            "能够使用ArkTS + ArkUI+axios+Navigation，配合三层架构、混合开发以及组件封装进行鸿蒙应用项目开发。学完此阶段，具备企业用人标准，可以达到中级前端开发工程师水平。",
          ability: [
            {
              name: "鸿蒙应用开发：",
              txt: "掌握鸿蒙应用开发核心技能：ArtTS语言核心声明式UI方式，掌握鸿蒙常用能力集，掌握鸿蒙APP开发能力，掌握鸿蒙混合应用开发，掌握元服务和端云一体化鸿蒙开发能力。",
            },
            {
              name: "美蔻商城项目：",
              txt: '美蔻商城是一个"一对多"的电商购物应用，提供在线购物的核心服务，涵盖了商品列表、商品详情、购物车、商品评价、订单管理等功能。该项目基于鸿蒙一对多开发范式，采用了三层工程架构配合多种UI适配方式，最终实现"一次开发，多端部署的核心目标",同时也应用了鸿蒙系统的多种能力，比如多媒体技术，支付能力、混合开发等等。',
            },
          ],
        },
        {
          stage: "阶段八",
          title: "React.js",
          content: [
            "useEffect Hook 的应用&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
            "Hooks 原理",
            "基于React全家桶（ React + Hooks + Redux Tookit ）实现多种业务场景下的功能开发"
          ],
          light:
            "通过 React + Hooks + Redux Toolkit 的学习，配合常用组件库解决项目中的一些共性问题，满足前端开发行业中的常见需求。学完此阶段，具备企业用人标准，能够达到中级前端开发工程师水平。",
          ability: [
            {
              name: "React 核心技术：",
              txt: "基于 React 脚手架（create-react-app）搭建React项目，掌握JSX语法搭建页面结构，使用函数组件实现组件化开发，掌握组件通讯在项目开发中的使用。",
            },
            {
              name: "Hooks 深入+路由：",
              txt: "掌握 useEffect Hook 的应用，掌握 useRef Hook 的高级用法，理解 Hooks 原理，掌握 react-router-dom 的应用。",
            },
            {
              name: "Redux +中间件 + Redux Toolkit：",
              txt: "掌握 React 最常用状态管理工具 Redux 的基本使用，使用 react-redux 链接库在 React 中使用 Redux，掌握 Redux 中间件 redux-thunk 用来处理异步请求，掌握 Redux Tookit 简化 Redux 的使用。",
            },
            {
              name: "记账本案例：",
              txt: "利用 React + Hooks + Redux Tookit 实现记账本案例，对整个 React 阶段所学内容进行练习，验证我们是否掌握了 React 开发能力。",
            }
          ],
        },
        {
          stage: "阶段九",
          title: "前端就业加强课",
          content: [
            "前端常见面试题（HTML+ CSS、HTTP协议、TCP协议、浏览器原理、JavaScript、Vue、项目等）",
            "前端技术解决方案",
            "JS原理",
            "Three.js"
          ],
          light:
            "通过学习前端面试题+前端技术解决方案+JS原理，学完此阶段，具备企业用人标准，能够达到中级前端开发工程师水平。",
          ability: [
            {
              name: "就业加强课：",
              txt: "就业加强课中包含了前端大部分面试中常见面试题、前端技术解决方案、JS原理、Three.js。",
            }
          ],
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
         this.clickZiXun()
      }
          this.mai("HTML&JS+前端-就业课","快速了解前端",0,null)
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
        this.cur = index;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },

  },
};
</script>

<style lang="less" scoped>
.box5 {
  width: 100%;
  background:linear-gradient(180deg, #ecfbf1 0%, #F5FFF8), url("../../../assets/coursePage/web/box5/bgc.png") no-repeat
    ;
  background-size: contain;
  //  background-image: linear-gradient(8deg, #006aff 0%, #33b0ff 100%);
  .box5block {
    height: 80px;
  }
  .box5-btm-box {
    padding-bottom: 88px;
    width: 100%;

    .box5-btm {
      margin-top: 48px;
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(129deg, #0ccb84 0%, #25ceed 100%);
    box-shadow: 0px 4px 12px 0px rgba(64, 255, 189, 0.12);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
    line-height: 96px;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    background: #ffffff;
    border-radius: 16px;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 24px 32px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    .stage {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: bold;
      line-height: 96px;
      letter-spacing: 0px;
      white-space: nowrap;
      color: #00b589;
    }

    .title {
      margin-left: 24px;
      margin-right: 20px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #24375c;
      width: 496px;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px;
    .line {
      margin: 0 auto;
      margin-bottom: 32px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 40px;
    border-radius: 16px;
    // display: block;
    max-height: 2400px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;
    margin-bottom: 16px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 48px;
    display: flex;
    flex-wrap: wrap;
    .block {
      width: 100%;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-left: 44px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }

  .main-text {
    margin-bottom: 48px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    margin-left: 45px;
  }
  .main-text2 {
    margin-bottom: 48px;
    p {
      margin-bottom: 16px;
    }
  }
}
</style>
